/**
 * Environment configuration file
 * This file provides environment-specific configuration values
 */

// Define fallback values for critical config
const DEFAULT_BACKEND_URLS = {
  production: 'https://us-central1-dream-book-3d-prod.cloudfunctions.net/api',
  staging: 'https://us-central1-dream-book-3d-staging.cloudfunctions.net/api',
  development: 'https://us-central1-dream-book-3d.cloudfunctions.net/api'
};

// PayPal plan IDs for different environments
const PAYPAL_PLAN_IDS = {
  development: {
    MONTHLY: 'P-8L26467138836311YM72W5NA',
    SIX_MONTH: 'P-15R053439X9159549M72W43I',
    ANNUAL: 'P-72S739948C947114EM72WWYA'
  },
  staging: {
    MONTHLY: 'P-8L26467138836311YM72W5NA',
    SIX_MONTH: 'P-15R053439X9159549M72W43I',
    ANNUAL: 'P-72S739948C947114EM72WWYA'
  },
  production: {
    MONTHLY: 'P-7JA257205R006231BM72YRVI',
    SIX_MONTH: 'P-6EX29499XG702853NM72YUGA',
    ANNUAL: 'P-86889995GJ1444908M72YUXI'
  }
};

// Determine environment
const env = process.env.REACT_APP_ENV || 'development';

// Get appropriate backend URL based on environment
const getBackendUrl = () => {
  // First try to use the environment variable
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // Fall back to default URLs based on environment
  return DEFAULT_BACKEND_URLS[env] || DEFAULT_BACKEND_URLS.development;
};

// Get PayPal plan IDs based on environment
const getPayPalPlanIds = () => {
  return PAYPAL_PLAN_IDS[env] || PAYPAL_PLAN_IDS.development;
};

const config = {
  env: env,
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
  },
  backendUrl: getBackendUrl(),
  isProduction: env === 'production',
  isStaging: env === 'staging',
  isDevelopment: env === 'development',
  useEmulators: process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true',
  bypassPaypal: process.env.REACT_APP_BYPASS_PAYPAL === 'true' || env === 'staging',
  paypalPlans: getPayPalPlanIds(),
  paypalClientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
  paypalApi: process.env.REACT_APP_PAYPAL_API
};

export default config;